export const API_BASE_URL = "https://api.myfarelanes.com/api/";

export const COPILOT_MONTHLY_API_KEY = "price_1SwbinLgudBKYy4G1PaJhSM1";
export const COPILOT_YEARLY_API_KEY = "price_1Swc07LgudBKYy4G2UVCTkVW";

export const SILVER_MONTHLY_API_KEY = "price_1Swbq6LgudBKYy4GSiJoZ3Lr";
export const SILVER_YEARLY_API_KEY = "price_1SwbsLLgudBKYy4G8OaCV65X";



export const GOLD_MONTHLY_API_KEY = "price_1SwbtzLgudBKYy4GOXMJEZKp";
export const GOLD_YEARLY_API_KEY = "price_1SwbwGLgudBKYy4GOiWFTMwF";


export const PLATINUM_MONTHLY_API_KEY = "price_1SwbxKLgudBKYy4GXkYhxyiq";
export const PLATINUM_YEARLY_API_KEY = "price_1PwJbALgudBKYy4Gwn8M9xfn";


export const STRIPE_KEY = "pk_live_51NXRnlLgudBKYy4GBVhkCeRQtdDwtrhOqCL51PDLdtVlqoCoLlaDA0Fc18cBb2tnYI7vHW4TaGpZ9CGTWbxZzmCk00INbqOUxq";

export const MONGO_CHARTS_AUTH_SIGN_KEY = "kjdflkdjflkdf87dkfnj8787jsdhs878";
export const MONGO_CHARTS_AUTH_SIGN_KEY_ALGORITHM = "HS256";
export const MONGO_CHARTS_AUTH_SIGN_KEY_USER = "FarelanesWeb";
export const MONGO_CHARTS_AUTH_SIGN_KEY_ISSUER = "FarelanesWeb";
export const MONGO_CHARTS_AUTH_SIGN_KEY_AUDIENCE = "FarelanesWeb";
export const MONGO_CHARTS_AUTH_SIGN_KEY_EXPIRY_TIME = "2h";
export const MONGO_CHARTS_BASE_URL = "https://charts.mongodb.com/charts-project-0-qpmdy";
